<adaa-data-table
    titleHeader="tasks.tasks"
    [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.AGM_TASK_MILESTONES_CONF_LIST"
    [enableExport]="false"
    [enableAdd]="true"
    [enableViewAction]="false"
    [isLocalData]="true"
    [localData]="tasksData"
    (addNewClicked)="addNewClicked()"
    (actionClicked)="actionClicked($event)"
/>
